import * as React from 'react'
import { useEffect } from 'react'
import { Video } from 'expo-av'
import { Box, Button, HStack, Image, Text, VStack, ZStack } from 'native-base'
import { ResizeMode } from 'expo-av/src/Video.types'
import { AVPlaybackStatusSuccess } from 'expo-av/src/AV.types'
import { pp, ppw } from '../Utils/LogUtil'
import Colors from '../Constants/Colors'
import axiosClient from '../Services/GenkiApiAxios'
import { AppResponse } from '../Entities/BaseApi'
import PopupGachaResult from '../Components/GachaPopupResultComponent'
import LoadingView from '../Components/LoadingView'
import { isAppError } from '../Utils/RequestUtil'
import { useTranslation } from 'react-i18next'
import PopupMessage from '../Components/PopupMessage'

const GachaContainer = () => {
  //========== HOOK ==========
  const { t } = useTranslation()

  let videoUri = require('../Assets/Videos/video_gacha.mp4')
  let posterUri = require('../Assets/Images/gacha_poster.jpg')

  const video = React.useRef(null)
  let videoCurrent: Video | null = video?.current
  const [videoStatusSuccess, setVideoStatusSuccess] = React.useState<
    AVPlaybackStatusSuccess | undefined
  >(undefined)
  const [videoIsFinish, setVideoIsFinish] = React.useState<boolean | undefined>(
    undefined
  )

  const [isLoading, setLoading] = React.useState<boolean>(false)
  const [turnCount, setTurnCount] = React.useState<number>(0)
  const [drawQuantity, setDrawQuantity] = React.useState<number | null>(null)
  const [result, setResult] = React.useState<GachaDrawRes | null>(null)
  const [error, setError] = React.useState<string | null>(null)

  //========== TURN ==========
  const getTurnCountText = (count: number) => {
    // return `残り ${count} 回`
    return t(`Remain val times`, { val: count })
  }

  //========== API ==========
  useEffect(() => {
    pp('useEffect().apiRemain()')
    apiRemain()
  }, [])

  useEffect(() => {
    if (videoIsFinish && drawQuantity !== null) {
      pp('useEffect().apiDraw()')
      apiDraw({ quantity: drawQuantity })
    }
  }, [videoIsFinish])

  useEffect(() => {
    // ppw('useEffect().error', error)
  })

  const apiRemain = async () => {
    try {
      pp('apiRemain()')
      setLoading(true)

      let appRes: AppResponse<GachaRemainRes> = await axiosClient.get(
        'lucky-draw/remain'
      )

      ppw('apiRemain().appRes', appRes)

      setTurnCount(appRes.body.remain)
    } catch (e) {
      ppw('apiRemain().e: ', e)
    } finally {
      setLoading(false)
    }
  }

  const apiDraw = async (request: { quantity: number }) => {
    try {
      pp('apiDraw()')
      setLoading(true)
      let appRes: AppResponse<GachaDrawRes> = await axiosClient.post(
        'lucky-draw/draw',
        { ...request }
      )

      ppw('apiDraw().appRes', appRes)

      setResult(appRes.body)
      setTurnCount(appRes.body.remain)
    } catch (e: any) {
      ppw('apiDraw().e', e)
      let message = isAppError(e) ? e.errorCode : 'UNEXPECTED_ERROR'
      message = message ?? 'UNEXPECTED_ERROR'
      setError(message)
    } finally {
      setVideoIsFinish(undefined)
      setTimeout((value) => {
        setLoading(false)
      }, 500)
    }
  }

  //========== LISTENER ==========
  const onClosePopupMessageError = () => {
    pp('onClosePopupMessageError()')
    setError(null)
  }

  const onClosePopupGachaResult = () => {
    pp('onClosePopupGachaResult()')
    setTimeout((value) => {
      setResult(null)
    }, 500)
  }

  //========== OUT ==========
  return (
    <Box
      style={{
        backgroundColor: 'white',
        height: '100%',
      }}
    >
      <LoadingView isOpen={isLoading} />
      {result != null && (
        <PopupGachaResult result={result} onClose={onClosePopupGachaResult} />
      )}
      {error != null && (
        <PopupMessage
          isOpen={true}
          message={t(error)}
          onClose={onClosePopupMessageError}
        />
      )}
      <ZStack
        style={{
          width: '100%',
          height: 300,
          marginTop: 32,
        }}
      >
        <Box width={'100%'}>
          <Video
            ref={video}
            videoStyle={{ width: '100%', height: 300 }}
            style={{
              alignSelf: 'center',
              width: '100%',
              height: 300,
              // backgroundColor: Colors.chartGray,
            }}
            source={videoUri}
            useNativeControls={false}
            resizeMode={ResizeMode.CONTAIN}
            isLooping={false}
            onPlaybackStatusUpdate={(status) => {
              if ('isPlaying' in status) {
                ppw('status.didJustFinish', status.didJustFinish)
                setVideoStatusSuccess(status)
                setVideoIsFinish(status.didJustFinish)
              }
            }}
          />
        </Box>
        {!videoStatusSuccess?.isPlaying && (
          <Image
            height={300}
            backgroundColor={Colors.white}
            source={posterUri}
            resizeMode={'contain'}
            width={'100%'}
          />
        )}
      </ZStack>
      <Box
        display={'flex'}
        width={'100vw'}
        justifyContent={'center'}
        alignItems={'center'}
        // bg={'yellow.200'}
      >
        {videoCurrent && videoStatusSuccess && (
          <VStack display={'flex'} width={'100vw'}>
            <HStack
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              // bg={'red.200'}
              pt={'24px'}
              pb={'12px'}
            >
              <Button
                isDisabled={videoStatusSuccess.isPlaying}
                width={'40vw'}
                shadow={4}
                style={{
                  backgroundColor: Colors.primaryColor,
                  padding: 16,
                  borderRadius: 8,
                }}
                _text={{
                  color: 'black',
                  fontSize: 20,
                  fontWeight: 'bold',
                }}
                onPress={() => {
                  if (turnCount <= 0) {
                    setError('LuckyDraw_E_001')
                    return
                  }
                  videoStatusSuccess.isPlaying
                    ? videoCurrent?.pauseAsync()
                    : videoCurrent?.replayAsync()
                  setTimeout((args) => {
                    setDrawQuantity(1)
                  }, 500)
                }}
              >
                <Text
                  px={'8px'}
                  color={'black'}
                  fontWeight={'bold'}
                  maxWidth={'40vw'}
                  fontSize={20}
                >
                  {t('Sprint')}
                </Text>
              </Button>
            </HStack>

            <HStack
              // bg={'blue.200'}
              display={'flex'}
              justifyContent={'center'}
              pt={'12px'}
              pb={'24px'}
              px={'16px'}
            >
              <Button
                flex={1}
                shadow={4}
                isDisabled={turnCount < 5 || videoStatusSuccess.isPlaying}
                style={{
                  backgroundColor: Colors.primaryColor,
                  padding: 16,
                  borderRadius: 8,
                }}
                onPress={() => {
                  if (turnCount <= 0) {
                    setError('LuckyDraw_E_001')
                    return
                  }
                  videoStatusSuccess.isPlaying
                    ? videoCurrent?.pauseAsync()
                    : videoCurrent?.replayAsync()
                  setTimeout((args) => {
                    setDrawQuantity(5)
                  }, 500)
                }}
              >
                <Text
                  px={'8px'}
                  color={'black'}
                  fontWeight={'bold'}
                  maxWidth={'40vw'}
                  fontSize={20}
                  textAlign={'center'}
                >
                  {t('Sprint5')}
                </Text>
              </Button>

              <Box width={'24px'} />
              <Button
                isDisabled={turnCount < 10 || videoStatusSuccess.isPlaying}
                flex={1}
                shadow={4}
                style={{
                  backgroundColor: Colors.primaryColor,
                  padding: 16,
                  borderRadius: 8,
                }}
                _disabled={{
                  backgroundColor: Colors.chartGray,
                }}
                onPress={() => {
                  if (turnCount <= 0) {
                    setError('LuckyDraw_E_001')
                    return
                  }
                  videoStatusSuccess.isPlaying
                    ? videoCurrent?.pauseAsync()
                    : videoCurrent?.replayAsync()
                  setTimeout((args) => {
                    setDrawQuantity(10)
                  }, 500)
                }}
              >
                <Text
                  px={'8px'}
                  color={'black'}
                  fontWeight={'bold'}
                  maxWidth={'40vw'}
                  fontSize={20}
                  textAlign={'center'}
                >
                  {t('Sprint10')}
                </Text>
              </Button>
            </HStack>
          </VStack>
        )}
        {/*<Text>{`videoIsFinish: ${videoIsFinish}`}</Text>*/}
        <Text fontSize={24}>{getTurnCountText(turnCount)}</Text>
      </Box>
    </Box>
  )
}

export default GachaContainer
